import { Component, Input, OnInit } from '@angular/core';
import { UserGroupService } from '../../core/services/user-group.service';
import { UserGroupWithMembersDTO } from '@sb-tools/typescript/models/dto/user-group-with-members.dto';
import { finalize } from 'rxjs/internal/operators/finalize';
import { RightPanelType } from '../../core/enums/right-panel-type.enum';
import { RightPanelService } from '../../core/services/right-panel.service';
import { LoaderComponent } from '../../../sb-tools/typescript/components/loader/loader.component';
import { UserAvatarComponent } from '../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';

@Component({
    selector: 'app-group-info',
    templateUrl: './group-info.component.html',
    styleUrls: ['./group-info.component.scss'],
    imports: [LoaderComponent, UserAvatarComponent],
})
export class GroupInfoComponent implements OnInit {
    @Input() groupId: number;

    group: UserGroupWithMembersDTO;
    isLoading = true;
    readonly rightPanelTypeEnum = RightPanelType;

    constructor(
        private userGroupService: UserGroupService,
        public rightPanelService: RightPanelService,
    ) {}

    ngOnInit() {
        this.userGroupService
            .get(this.groupId)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe((group) => {
                this.group = group;
            });
    }
}
